import { render, staticRenderFns } from "./GroupingSelection.vue?vue&type=template&id=6ff45e10&scoped=true&"
import script from "./GroupingSelection.vue?vue&type=script&lang=js&"
export * from "./GroupingSelection.vue?vue&type=script&lang=js&"
import style0 from "./GroupingSelection.vue?vue&type=style&index=0&id=6ff45e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff45e10",
  null
  
)

export default component.exports